module.exports = __webpack_public_path__ + "img/erro404.edd27a71.svg";